import React, { useEffect, useRef, useState } from 'react'
import ItemsApp, { IItemModel } from './ItemsApp'
import ApplicationLogo from '../../components/ApplicationLogo'
import DataDisplayer, { IDataDisplayer, IDataDisplayerItem, IDataDisplayerItemField } from '../../components/DataDisplayer/DataDisplayer'
import HeaderDataDisplayer from '../../components/DataDisplayer/HeaderDataDisplayer'
import DataDisplayerItem from '../../components/DataDisplayer/DataDisplayerItem'
import { Button } from '@mui/material'
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import CategoriesApp, { ICategoryModel } from '../categories/CategoriesApp'

interface IProps {
    items: IItemModel[],
    title: string,
    details?: string,
    showSignatureBlock?: boolean,
    groupByCategories?: boolean,
    simplifyItems?: boolean
}

export default function ItemsListPDF(props: IProps) {

    const contentRef = useRef<HTMLDivElement>(null)
    const containerRef = useRef<HTMLDivElement>(null)

    const { items, showSignatureBlock, title, details, groupByCategories, simplifyItems } = props

    const [displayerItems, setDisplayerItems] = useState<IDataDisplayerItem[]>([])
    const [categoriesList, setCategoriesList] = useState<number[]>([])

    const [categories, setCategories] = useState<ICategoryModel[]>([])

    const categoriesApp = new CategoriesApp()
    const itemsApp = new ItemsApp()

    const displayer: IDataDisplayer = {
        name: "items_pdf_export_list_displayer",
        search: "",
        items: [],
        pagination: {
            count: 0,
            total_pages: 0,
            current_page: 1
        },
        loading: false,
        columnItems: [
            {
                id: "id",
                type: "text",
                label: "#",
                maxWidth: 50,
                minWidth: 50,
            },
            {
                id: "thumbnail",
                type: "thumbnail",
                label: "Image",
                maxWidth: 150,
                minWidth: 150,
            },
            {
                id: "title",
                type: "text",
                label: "Item",
                maxWidth: 300,
                minWidth: 300,
            },
            // {
            //     id: "serial_number",
            //     type: "text",
            //     label: "Serial Number",
            //     maxWidth: 200,
            //     minWidth: 200,
            // },
            {
                id: "quantity",
                type: "text",
                label: "Quantity",
                maxWidth: 100,
                minWidth: 100,
            },
            {
                id: "unique_id",
                type: "text",
                label: "Unique ID",
                maxWidth: 205,
                minWidth: 205,
            },
        ],
        notionFound: {
            title: "Nothing...",
            message: "No items have been found :("
        },
        loadItems: (page, search, disablePagination, addItems, searchParams) => {},
        deleteItem: (id) => {},
        deleteManyItems: (records) => {},
        updateSearch: (search) => {},
        disableSearch: true,
        selectedItems: [],
        hideColumnItems: [],
        disableSelect: true
    }

    /**
     * Add category
     */
    const addCategoryIfNotExists = (id: number) => {
        setCategoriesList(prev => {
            if (!prev.includes(id)) {
                return [...prev, id]
            }
          return prev;
        });
    }

    /**
     * Create data displayer items
     */
    useEffect(() => {
        if (items.length > 0){
            let list: IDataDisplayerItem[] = []

            if (!simplifyItems){
                items.map((item, index) => {
                    list.push({
                        id: item.id,
                        fields: [
                            {
                                id: "id",
                                type: "text",
                                label: "#",
                                maxWidth: 50,
                                minWidth: 50,
                                value: `${index + 1}`
                            },
                            {
                                id: "thumbnail",
                                type: "thumbnail",
                                label: "Image",
                                maxWidth: 150,
                                minWidth: 150,
                                value: item.thumbnail
                            },
                            {
                                id: "title",
                                type: "text",
                                label: "Item",
                                maxWidth: 300,
                                minWidth: 300,
                                value: item.title
                            },
                            // {
                            //     id: "serial_number",
                            //     type: "text",
                            //     label: "Serial Number",
                            //     maxWidth: 200,
                            //     minWidth: 200,
                            //     value: item.serial_number
                            // },
                            {
                                id: "quantity",
                                type: "text",
                                label: "Quantity",
                                maxWidth: 100,
                                minWidth: 100,
                                value: String(item.quantity)
                            },
                            {
                                id: "unique_id",
                                type: "text",
                                label: "Unique ID",
                                maxWidth: 205,
                                minWidth: 205,
                                value: item.unique_id
                            },
                        ],
                        rawItem: item,
                        subItems: []
                    })

                    addCategoryIfNotExists(item.category_id)

                })
            }else{
                /**
                 * Simplified Items
                 */
                interface SimplfiedItem extends IItemModel {
                    quantity: number
                }

                let simplifedItems: SimplfiedItem[] = []

                items.map((item) => {
                    if (simplifedItems.find(sItem => sItem.title === item.title)){

                        const itemIndex = simplifedItems.findIndex(findItem => findItem.title === item.title)

                        if (simplifedItems[itemIndex]){
                            simplifedItems[itemIndex] = {
                                ...item,
                                quantity: simplifedItems[itemIndex].quantity + 1
                            }
                        }

                    }else{
                        simplifedItems.push({
                            ...item,
                            quantity: item.quantity
                        })
                    }
                })

                /**
                 * Create data displayer items
                 */
                simplifedItems.map((simplifedItem, index) => {
                    list.push({
                        id: simplifedItem.id,
                        fields: [
                            {
                                id: "id",
                                type: "text",
                                label: "#",
                                maxWidth: 50,
                                minWidth: 50,
                                value: `${index + 1}`
                            },
                            {
                                id: "thumbnail",
                                type: "thumbnail",
                                label: "Image",
                                maxWidth: 150,
                                minWidth: 150,
                                value: simplifedItem.thumbnail
                            },
                            {
                                id: "title",
                                type: "text",
                                label: "Item",
                                maxWidth: 300,
                                minWidth: 300,
                                value: simplifedItem.title
                            },
                            {
                                id: "quantity",
                                type: "text",
                                label: "Quantity Number",
                                maxWidth: 100,
                                minWidth: 100,
                                value: `${simplifedItem.quantity}`
                            },
                            {
                                id: "unique_id",
                                type: "text",
                                label: "Unique ID",
                                maxWidth: 205,
                                minWidth: 205,
                                value: simplifedItem.unique_id
                            },
                        ],
                        rawItem: simplifedItem
                    })
                })

            }

            setDisplayerItems(list)
        }
    }, [items, simplifyItems])
    useEffect(() => {
        const fetchData = async () => {
            let list: IDataDisplayerItem[] = []
    
            if (items.length === 0) {
                setDisplayerItems([])
                return
            }
    
            const isSimple = simplifyItems
            const containerPromises: Array<Promise<void>> = []
    
            if (!isSimple) {
                items.forEach((item, index) => {
                    const fields: IDataDisplayerItemField[] = [
                        {
                            id: "id",
                            type: "text",
                            label: "#",
                            maxWidth: 50,
                            minWidth: 50,
                            value: `${index + 1}`
                        },
                        {
                            id: "thumbnail",
                            type: "thumbnail",
                            label: "Image",
                            maxWidth: 150,
                            minWidth: 150,
                            value: item.thumbnail
                        },
                        {
                            id: "title",
                            type: "text",
                            label: "Item",
                            maxWidth: 300,
                            minWidth: 300,
                            value: item.title
                        },
                        {
                            id: "quantity",
                            type: "text",
                            label: "Quantity",
                            maxWidth: 100,
                            minWidth: 100,
                            value: String(item.quantity)
                        },
                        {
                            id: "unique_id",
                            type: "text",
                            label: "Unique ID",
                            maxWidth: 205,
                            minWidth: 205,
                            value: item.unique_id
                        }
                    ]
    
                    const displayerItem: IDataDisplayerItem = {
                        id: item.id,
                        fields,
                        rawItem: item,
                        subItems: []
                    }
    
                    // Handle sub-items if container
                    if (item.is_container) {
                        const subItemPromise = itemsApp.returnContainerItemList(item.id)
                            .then((res) => {
                                const containerItems = res.data || []
                                displayerItem.subItems = containerItems.map((subItem: IItemModel, subIndex: number) => ({
                                    id: subItem.id,
                                    fields: [
                                        {
                                            id: "thumbnail",
                                            type: "thumbnail",
                                            label: "thumbnail",
                                            value: subItem.thumbnail
                                        },
                                        {
                                            id: "title",
                                            type: "text",
                                            label: "Item",
                                            value: subItem.title,
                                            maxWidth: 290,
                                            minWidth: 290
                                        },
                                        {
                                            id: "quantity",
                                            type: "text",
                                            label: "Quantity",
                                            value: `${subItem.quantity}`,
                                            maxWidth: 102,
                                            minWidth: 102
                                        },
                                        {
                                            id: "unique_id",
                                            type: "text",
                                            label: "Unique ID",
                                            value: subItem.unique_id
                                        }
                                    ],
                                    rawItem: subItem
                                }))
                            })
                            .catch(err => {
                                console.error(`Failed to fetch sub-items for container ${item.id}`, err)
                            })
    
                        containerPromises.push(subItemPromise)
                    }
    
                    list.push(displayerItem)
                    addCategoryIfNotExists(item.category_id)
                })
            } else {
                // Simplified logic
                interface SimplfiedItem extends IItemModel {
                    quantity: number
                }
    
                const simplifiedItemsMap = new Map<string, SimplfiedItem>()
    
                items.forEach((item) => {
                    const key = item.title // could add category_id or other fields if needed
    
                    if (simplifiedItemsMap.has(key)) {
                        const existing = simplifiedItemsMap.get(key)!
                        simplifiedItemsMap.set(key, {
                            ...existing,
                            quantity: existing.quantity + item.quantity
                        })
                    } else {
                        simplifiedItemsMap.set(key, {
                            ...item,
                            quantity: item.quantity
                        })
                    }
                })
    
                const simplifedItems = Array.from(simplifiedItemsMap.values())
    
                simplifedItems.forEach((simplifedItem, index) => {
                    const fields: IDataDisplayerItemField[] = [
                        {
                            id: "id",
                            type: "text",
                            label: "#",
                            maxWidth: 50,
                            minWidth: 50,
                            value: `${index + 1}`
                        },
                        {
                            id: "thumbnail",
                            type: "thumbnail",
                            label: "Image",
                            maxWidth: 150,
                            minWidth: 150,
                            value: simplifedItem.thumbnail
                        },
                        {
                            id: "title",
                            type: "text",
                            label: "Item",
                            maxWidth: 300,
                            minWidth: 300,
                            value: simplifedItem.title
                        },
                        {
                            id: "quantity",
                            type: "text",
                            label: "Quantity Number",
                            maxWidth: 100,
                            minWidth: 100,
                            value: `${simplifedItem.quantity}`
                        },
                        {
                            id: "unique_id",
                            type: "text",
                            label: "Unique ID",
                            maxWidth: 205,
                            minWidth: 205,
                            value: simplifedItem.unique_id
                        }
                    ]
    
                    list.push({
                        id: simplifedItem.id,
                        fields,
                        rawItem: simplifedItem,
                        subItems: [] // optional: if you want to fetch subitems even for simplified view
                    })
                })
            }
    
            await Promise.all(containerPromises)
            setDisplayerItems(list)
        }
    
        fetchData()
    }, [items, simplifyItems])


    /**
     * Update categories
     */
    useEffect(() => {

        let newList: ICategoryModel[] = [
            ...categories
        ]

        categoriesList.sort((a, b) => a - b).forEach((catId) => {
            const alreadyExists = newList.some(cat => cat.id === catId)
            if (!alreadyExists) {
                categoriesApp.singleInstanceDetails(Number(catId))
                    .then(response => {
                        setCategories(prev => [...prev, response.data].sort((a, b) => a.id - b.id))
                    })
            }
        })

    }, [categoriesList])

    /**
     * Handle print
     */

    const handleDownloadPdf = async () => {
        const content = contentRef.current;
        if (!content) return;
      
        try {
          const pdf = new jsPDF("p", "mm", "a4");
          const pdfWidth = pdf.internal.pageSize.getWidth();
          const pdfHeight = pdf.internal.pageSize.getHeight();
      
          // Render the entire content to a canvas
          const canvas = await html2canvas(content, {
            scale: 1,
            useCORS: true, // Ensures external images are included
          });
      
          const imgWidth = pdfWidth;
          const imgHeight = (canvas.height * pdfWidth) / canvas.width;
      
          let currentHeight = 0;
      
          while (currentHeight < canvas.height) {
            const sliceCanvas = document.createElement("canvas");
            sliceCanvas.width = canvas.width;
            sliceCanvas.height = Math.min(canvas.height - currentHeight, (pdfHeight * canvas.width) / pdfWidth);
      
            const sliceContext = sliceCanvas.getContext("2d");
            if (sliceContext) {
              sliceContext.drawImage(
                canvas,
                0,
                currentHeight,
                canvas.width,
                sliceCanvas.height,
                0,
                0,
                sliceCanvas.width,
                sliceCanvas.height
              );
      
              const imgData = sliceCanvas.toDataURL("image/png");
      
              if (currentHeight > 0) pdf.addPage();
              pdf.addImage(imgData, "PNG", 0, 0, imgWidth, pdfHeight);
            }
      
            currentHeight += sliceCanvas.height;
          }
      
          pdf.save(title + ".pdf");
        } catch (error) {
          console.error("Error generating PDF:", error);
          alert("Failed to generate PDF. Please check your content.");
        }
      };

    /**
     * Render all items
     */
    const renderAllItems = (categoryId?: Number) => {

        let count = 0

        let items = displayerItems.sort((a, b) => b.rawItem.category_id - a.rawItem.category_id)

        return(
            <>
                <HeaderDataDisplayer disableSelect={true} displayer={displayer} customColumnItems={displayer.columnItems} selectAllItems={() => {}} />
                <div className="items-of-data-displayer-container">
                    <div className="content-of-items-of-data-displayer-container">
                        {items.map((item, index) => {
                           
                            let itemDetails = {
                                ...item
                            }


                            if (categoryId){
                                if (categoryId !== item.rawItem.category_id){
                                    return <></>
                                }else{
                                    count++
                                }

                                itemDetails.fields[0].value = String(count)

                            }else{
                                count++

                                itemDetails.fields[0].value = String(count)
                            }

                            return <DataDisplayerItem {...itemDetails} key={index} selectedList={[]} hideColumns={[]} handleDeleteItem={(id) => {}} updateSelected={(id) => {}} itemActionOptions={[]} disableSelect />
                        })}
                    </div>
                </div>
            </>
        )
    }

    const categoryCounts: Record<number, number> = items.reduce((acc, item) => {
        acc[item.category_id] = (acc[item.category_id] || 0) + 1;
        return acc;
      }, {} as Record<number, number>)

    /**
     * Render items by group
     */
    const renderItemsByGroup = () => {
        if (categories.length > 0){
            return categories.map((category, index: number) => {

                return(
                    <div className="items-pdf-list-by-category-container" key={index}>
                        <div className="content-of-items-pdf-list-by-category-container">

                            <h3 className="head-title">{category.title} ({categoryCounts[category.id] || 0})</h3>

                            <div className="items-box-of-items-pdf-list-by-category-container">
                                {renderAllItems(category.id)}
                            </div>

                        </div>
                    </div>
                )
            })
        }

        return renderAllItems()
    }

    /**
     * Render items
     */
    const renderItems = () => {
        if (groupByCategories){
            return renderItemsByGroup()
        }else{
            return renderAllItems()
        }
    }

    return(
        <div className="a4-page-modal-container hidden-for-pdf" ref={containerRef}>
            <Button id="print-items-export-button" onClick={() => handleDownloadPdf()}>Print</Button>


            <div className="a4-page-container items-export" ref={contentRef}>
                <div className="content-of-a4-page-container">

                    <div className="header-box-of-a4-page-container">
                        <div className="content-of-header-box-of-a4-page-container">

                            <div className="logo-of-header-box-of-a4-page-container">
                                <ApplicationLogo />
                            </div>

                        </div>
                    </div>

                    <div className="page-info-of-a4-page-container">
                        <div className="content-of-page-info-of-a4-page-container">
                            <h1>{title}</h1>
                            {details && (
                                <div className="page-text-container">
                                    {details}
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="items-of-a4-page-container">
                        {/* <div className="items-of-data-displayer-container">
                            <div className="content-of-items-of-data-displayer-container">
                                {displayerItems.map((item, index) => <DataDisplayerItem {...item} key={index} selectedList={[]} hideColumns={[]} handleDeleteItem={(id) => {}} updateSelected={(id) => {}} itemActionOptions={[]} disableSelect />)}
                            </div>
                        </div> */}
                        {renderItems()}
                    </div>

                    {showSignatureBlock && (
                        <div className="sign-blocks-container">
                            <div className="content-of-sign-blocks-container">

                                <div className="signature-block">
                                    <div className="content-of-signature-block">
                                        <div className="line-of-signature-block"></div>
                                        <p>Approved by:</p>
                                    </div>
                                </div>

                                <div className="signature-block">
                                    <div className="content-of-signature-block">
                                        <div className="line-of-signature-block"></div>
                                        <p>Received by:</p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    )}

                </div>
            </div>
        </div>
    )
}